/**
 * 首页-辅模块
 */
import request from '@/api/axios'
import { apiList as api } from './apiList'

// 获取班级类型、班级、学科下拉
export function getAllOptions(type) {
  return request({
    url: api.groupManage.getAllOptions + type,
    method: 'get',
  })
}

// 查询班级未分组学生信息
export function getNoTeamStudentList(data) {
  return request({
    url: api.groupManage.getNoTeamStudentList,
    method: 'post',
    data,
  })
}

// 查询班级分组学生信息
export function getTeamStudentLists(data) {
  return request({
    url: api.groupManage.getTeamStudentLists,
    method: 'post',
    data,
  })
}

// 添加分组信息
export function addGroup(data) {
  return request({
    url: api.groupManage.addGroup,
    method: 'post',
    data,
  })
}

// 添加分组信息
export function delGroup(id) {
  return request({
    url: api.groupManage.delGroup + id,
    method: 'delete',
  })
}

// 修改分组
export function updGroup(data) {
  return request({
    url: api.groupManage.updGroup,
    method: 'post',
    data,
  })
}

// 修改分组排序
export function updGroupSort(data) {
  return request({
    url: api.groupManage.updGroupSort,
    method: 'post',
    data,
  })
}

// 分组添加学生
export function addStudent(data) {
  return request({
    url: api.groupManage.addStudent,
    method: 'post',
    data,
  })
}

// 移除学生信息
export function delStudent(data) {
  return request({
    url: api.groupManage.delStudent,
    method: 'post',
    data,
  })
}

// 设置小组长
export function setHeadman(data) {
  return request({
    url: api.groupManage.setHeadman,
    method: 'post',
    data,
  })
}

// 设置学科班长
export function setSubjectMonitor(data) {
  return request({
    url: api.groupManage.setSubjectMonitor,
    method: 'post',
    data,
  })
}

// 取消学科班长
export function cancelSubjectMonitor(data) {
  return request({
    url: api.groupManage.cancelSubjectMonitor,
    method: 'post',
    data,
  })
}
